import { SENTRY_DSN as SENTRY_DSN_ENV } from 'react-native-dotenv';

// @TODO Find a better way to share envs between libs and apps

export const SENTRY_DSN = SENTRY_DSN_ENV;
export const ENVIRONMENT_NAME = process.env['APP_ENV'] ?? process.env['NODE_ENV'];
